/**
 * **Roiback**
 *
 * @exports partnership_8
 * @category partnerships
 */
function factory({ window, document, thn }) {
    const partnership = {};
    const dataLayer = window.dataLayer;
    const corporateMappings = {
        ciutathotels: 'E41CC2BD6BA1308E84D87C2093429975',
        trhhoteles: '75F4ED7BE354F0F00EBD11374BCD0BF8',
        manoiregina: '7421196C940EE9B8E19A4AB130D37CFE',
        'Palladium Group Hotels': 'E6F9D3656D91DEEDBF478626A9D6A623',
        'Bless Collecion Hotels': 'E6F9D3656D91DEEDBF478626A9D6A623',
        extendedsuites: 'F6633C33C26B08E3266DEF032AB8C8BE',
        dorado: 'A9F54CDF8422C76EF9C6D1FAEF96A6B5',
        krystalsantafe: '8D11B003012C12E8C517A260CA9F1F95',
    };
    const vincciMicroPageBookingEngine = /vinccibit|vinccigala|vinccimaritimo|vinccimae|ramblashotelbyvincci|vincciconsuladodebilbao|vinccivaldecanasgolf|vinccicostagolf|vinccialbayzin|vinccivia66|vinccisoho|vinccicapitol|vinccisoma|vinccithemint|vincciposadadelpatio|vinccimalaga|vincciestrelladelmar|vinccialeysa|vinccilariosdiez|vinccisalamanca|vinccilarabida|vinccimolviedro|vinccimolviedrosuitesapartments|vinccilaplantaciondelsur|vinccitenerifegolf|vinccilys|vinccipalace|vinccimercat|vinccifrontaura|vinccizaragozazentro|evereden|vinccibaixa|vincciliberdade|vincciporto|vinccipontedeferro|vinccipuertochico/;
    partnership.isMicrosite = function isMicrosite() {
        // Grupo BlueBay
        const isBlueBayMicrosite = window.location.hostname.match(/bluediamondluxuryboutiquehotel|bluebayhotels/);
        return isBlueBayMicrosite;
    };
    /**
          * @memberOf module:partnership_8
          */
    partnership.getId = function getId() {
        return '8';
    };
    /**
          * @memberOf module:partnership_8
          */
    partnership.check = function check() {
        return (!!thn.objectGet(dataLayer, 'supplier', { first: false })?.match(/roiback/i) && !window.location.hostname.match(vincciMicroPageBookingEngine)) || !!window.location.hostname.includes('palladium');
    };
    /**
          * @memberOf module:partnership_8
          */
    partnership.getSiteId = function getSiteId() {
        const hotelId = partnership.isMicrosite() ? thn.objectGet(dataLayer, 'hotelName', { first: false }) : thn.objectGet(dataLayer, 'hotelCode', { first: false });
        const chainId = thn.dataLayerHelper.get('chain')?.trim() || thn.dataLayerHelper.get('Marca');
        let result;
        if (hotelId) {
            result = {
                externalId: hotelId?.trim(),
            };
        }
        else if (chainId) {
            result = {
                accountKey: corporateMappings[chainId],
            };
        }
        return result;
    };
    return partnership;
}

export { factory };
